import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/check-2.svg")